<template>
    <div class="mt-16 px-6 h-full flex flex-col">
        <h2 class="text-2xl font-bold">{{ t('code_header') }}</h2>
        <div class=" max-w-lg mx-auto w-full pt-4 pb-6">
            <p class="text-base font-bold">{{ t('type_code') }}</p>
            <fieldset class="w-full flex justify-between gap-1 mt-2">
                <input
                    v-for="index in otpLength"
                    :key="index"
                    class="text-xl min-[395px]:text-3xl w-10 min-[395px]:w-14 h-10 min-[395px]:h-14 text-center border flex items-center justify-center [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                    :class="inputTheme"
                    type="number"
                    :value="parseInt(otp[index - 1])"
                    @input="evt => handleInput(index - 1, evt.target.value)"
                    :maxlength="1"
                    :min="0"
                    :max="9"
                    inputmode="numeric"
                    pattern="[0-9]*"
                    @keydown="handleKeyDown(index - 1)"
                    @paste="handlePaste(index - 1)"
                    @change="evt => handleChange(index - 1, evt.target.value)"
                    @focus="handleFocus(index - 1)"
                    @blur="handleBlur(index - 1)"
                    :ref="(el) => inputFields[index-1] = (el as Element)"
                    autocomplete="one-time-code"
                />
            </fieldset>
            <p class="text-white mt-2" @click="emitResendCode()">{{ t('no_code') }} <span class=" text-white cursor-pointer">{{ t('new_code') }}</span></p>
            <p v-if="error" class="">{{ t('code_error') }}</p>
            <p v-if="codeSentAgain" class="">{{ t('code_reset') }}</p>
            <Button @click="emitOpenDoor()" class="mt-6" :class="{' opacity-50 pointer-events-none' : codeFilled}" :loading="loading" :text="t('open_box')" type="step"></Button>
        </div>
    </div>
</template>

<script setup lang="ts">
    const { t } = useI18n()
    const emit = defineEmits(["update:modelValue", "resendCode"]);
    const otp = ref<string[]>([]);
    const inputFields = ref<Element[]>([]);
    const otpLength = ref<number>();
    const codeSentAgain = ref(false);
    //const route = 'bibliotek';
    const route = window.location.origin;

    const props = defineProps<{
        error: boolean;
        length: number;
        loading: boolean
    }>()

    onMounted(() => {
        otpLength.value = 6 //props.length;
        for (let i = 0; i < otpLength.value; i++) {
            otp.value.push("");
        }
    })

    const inputTheme = computed(() => {
        if (route.includes('nordvaerk')) {
            return 'border-secondary bg-secondary'
        } else if (route.includes('bibliotek')) {
            return 'border-white bg-white'
        } else {
            return 'border-secondary bg-secondary'
        }
    });

    const handleInput = (index: number, val) => {
        otp.value[index] = val + "";

        if (otp.value[index].length > 1) {
            otp.value[index] = otp.value[index].slice(0, 1);
        }
        if (otp.value[index].length === 1 && index < otpLength.value - 1) {
            const nextInput = inputFields.value[index + 1];

            if (nextInput) {
            nextInput.focus();
            }
        }
    };

    const handleKeyDown = (index: number) => {
        if (event.key === "Backspace" && index > 0) {
            otp.value[index] = "";
            const previousInput = inputFields.value[index - 1];
            if (previousInput) {
            previousInput.focus();
            }
        }
    };

    const codeFilled = computed(() => {
        return otp.value[otpLength.value - 1] == "";
    });

    const handleChange = (index: number, val) => {
        if(!val.match(/^[0-9]+$/)  || val.length !== otpLength.value) {
            return;
        }

        otp.value = val.split("");
        //focus on the last input
        const lastInput = inputFields.value[otpLength.value - 1];
        if (lastInput) {
            lastInput.focus();
        }
    };

    const handlePaste = (index: number) => {
        const clipboardData = event.clipboardData || window.clipboardData;
        const pastedData = clipboardData.getData("Text");

        if(!pastedData.match(/^[0-9]+$/)  || pastedData.length !== otpLength.value) {
            return;
        }

        otp.value = pastedData.split("");
        //focus on the last input
        const lastInput = inputFields.value[otpLength.value - 1];
        if (lastInput) {
            lastInput.focus();
        }
        };

    const handleFocus = (index: number) => {
        if (index > 0 && otp.value[index - 1].length === 0) {
            const previousInput = inputFields.value[index - 1];
            if (previousInput) {
            previousInput.focus();
            }
        }
    };

    const handleBlur = (index) => {
        if (otp.value[index].length === 0 && index < otpLength.value - 1) {
            const nextInput = inputFields.value[index + 1];
            if (nextInput) {
            nextInput.blur();
            }
        }
    // fieldBlur();
    };


    function emitOpenDoor() {
        emit("update:modelValue", {
            code: otp.value.join('')
        });
    };

    function emitResendCode() {
        codeSentAgain.value = true;
        emit("resendCode");
    }

</script>